import React from 'react';
import EquationEditor from 'equation-editor-react';
import TextInput from '../../pages/NewExam/TextInput';

var that = undefined;
export default class NuovaSceltaMultipla extends React.Component {
    constructor(props) {
        super(props);

        that = this;

        this.state = {
            domanda: '', 
            risposte: [
                { id: 1, risposta: '' }, 
                { id: 2, risposta: '' },
                { id: 3, risposta: '' },
                { id: 4, risposta: '' }
            ], 
            risposta_corretta: undefined, 
            trash: false, 
            deleted: false, 
            error: false, 
        };
    }

    getQuestion() {

        if (this.state.deleted) return { tipo: 'deleted' };

        var allRisposte = true;
        this.state.risposte.forEach((r) => {
            if (!r.risposta) allRisposte = false;
        });

        if (this.state.domanda && this.state.risposta_corretta && allRisposte) {
            
            this.setState({ error: false });

            var res = {
                tipo: 1, 
                domanda: this.state.domanda,
                risposta: this.state.risposta_corretta, 
                risposte: this.state.risposte, 
                allegato: this.state.attachment ? this.state.adding + ':///' + this.state.attachment : null,
            }
            return res;
        }

        this.setState({ error: true });
    }

    delete() {
        this.setState({ deleted: true });
    }

    setRisposta(id, text) {
        var risposte = this.state.risposte;
        risposte.forEach((r) => {
            if (r.id === id) {
                r.risposta = text;
            }
        });

        this.setState({ risposte });
    }

    handleFileSelected(e) {
        const files = Array.from(e.target.files)
        
        if (files[0].size <= 1048576) {
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = function () {
                that.setState({ attachment: reader.result });
            };
        } else {
            alert("Scegliere un'immagine con una dimensione massima di 1MB");
        }
    }

    render() {

        if (this.state.deleted) return <div />;

        return(
            <section className='question-container'>
                { this.state.error && ( <p style={{ color: '#C13F3F', fontWeight: 'bold' }}>Verifica di aver inserito tutti i dati in questa domanda.</p> )}
                <TextInput placeholder={'Testo della domanda'} value={this.state.domanda} fontSize={20} onChange={(text) => this.setState({ domanda: text })} />
                <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                    { !this.state.adding && (
                        <>
                            <p style={{ color: 'blue', cursor: 'pointer', fontSize: 14, fontWeight: 'bold', marginRight: 20 }} onClick={() => this.setState({ adding: 'img', attachment: '' })}>Aggiungi immagine</p>
                            <p style={{ color: 'blue', cursor: 'pointer', fontSize: 14, fontWeight: 'bold' }} onClick={() => this.setState({ adding: 'math', attachment: 'y=x' })}>Aggiungi formula</p>
                        </>
                    )}

                    { this.state.adding === 'math' && (
                        <EquationEditor
                            value={this.state.attachment}
                            onChange={(equazione) => this.setState({ attachment: equazione })}
                            autoCommands="pi theta sqrt sum prod alpha beta gamma delta rho"
                            autoOperatorNames='sin cos tan arccos arcsen arctan'
                        />
                    )}
                    { this.state.adding === 'img' && (
                        <div style={{ flexDirection: 'column' }}>
                            <input type={'file'} accept=".png, .jpg, .jpeg" onChange={this.handleFileSelected} />
                            { this.state.attachment && (
                                <img src={this.state.attachment} style={{ width: '50%', height: 'auto' }} />
                            )}
                        </div>
                    )}
                </section>
                <p style={{ color: '#818181', marginTop: 30, fontWeight: 'bold' }}>Risposte (selezionare poi quella corretta):</p>
                <div className='answer-container' style={{ flexDirection: 'column' }}>
                    { this.state.risposte.map((risposta) => {

                        return(
                            <section key={risposta.id} className='answer answer-selectable' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', paddingLeft: 20, paddingRight: 20, paddingTop: 10, paddingBottom: 10 }}>
                                <img src={ require('../../images/tick.png') } style={{ width: 20, height: 20, cursor: 'pointer', opacity: this.state.risposta_corretta === risposta.id ? 1.0 : 0.3 }} onClick={() => this.setState({ risposta_corretta: risposta.id })} />
                                <TextInput style={{ marginLeft: 15 }} placeholder={'Risposta'} value={risposta.risposta} fontSize={14} onChange={(text) => this.setRisposta(risposta.id, text)} />
                            </section>
                        );
                    })}
                </div>
                <img src={ require('../../images/trash.png') } style={{ position: 'absolute', right: 20, bottom: 20, width: 20, height: 20, cursor: 'pointer', opacity: this.state.trash ? 1 : 0.6 }} onMouseEnter={() => this.setState({ trash: true })} onMouseLeave={() => this.setState({ trash: false })} onClick={() => {
                    if (window.confirm('Vuoi davvero eliminare questa domanda?')) {
                        this.setState({ deleted: true });
                    }
                }} />
            </section>
        );
    }
}